<template>
  <div>左侧菜单</div>
</template>

<script>
export default {
  name: 'Navigation',
}
</script>

<style scoped>

</style>
